export function getAnchorIdsInText(text: string | undefined) {
    if (!text) {
        return [];
    }

    const ids: string[] = [];
    const matches = text.matchAll(/id="(.+?)"/g);
    for (const match of matches) {
        if (match.length === 2) {
            ids.push(match[1]);
        }
    }

    return ids;
}
